import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutTableTriumphPayAuditDocument extends Layout {
    sourceHubtranTrx: DataSource;
    tableHubtranTrx: Table;
}
